<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="确认组货"
      :innerHeight="140"
      :innerScroll="false"
      width="400px"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <el-form :model="form" size="small" :inline="true" :rules="rules" ref="ruleForm" label-width="110px" v-loading="loading">
        <el-form-item label="实际到货时间" prop="actualTime">
          <el-date-picker
            v-model="form.actualTime"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="配货人员" prop="distributionPersonId">
          <el-select 
            v-model="form.distributionPersonId"
            filterable=""
            placeholder="请选择"
            >
            <el-option
              v-for="item in userList"
              :key="item.userId"
              :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`"
              :value="item.userId">
            </el-option>
          </el-select>
          <!-- <el-input v-model.trim="form.distributionPerson" :maxlength="64"/> -->
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input v-model.trim="form.remarks"/>
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import axios from "@/utils/axiosInstance";
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: {
    visible: Boolean,
    skuId: String|Number,
    skuCode: String|Number,
    spuId: String|Number
  },
  data() {
    return {
      dialogVisible: false,
      // 业务
      form: {
        actualTime: '',
        distributionPersonId: '',
        remarks: ''
      },
      rules: {
        actualTime: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        distributionPersonId: [
          { required: true, message: '不能为空', trigger: 'change' },
          // { min: 1, max: 64, message: '长度在 1 到 64 个字符', trigger: 'change' }
        ]
      },
      loading: false,
      userList: []
    }
  },
  computed: {
    skuIds() {
      if(this.skuId instanceof Array) {
        return this.skuId
      }else{
        return [this.skuId]
      }
    },
    skuCodes() {
      if(this.skuCode instanceof Array) {
        return this.skuCode
      }else{
        return [this.skuCode]
      }
    },
  },
  mounted() {
    this.dialogVisible = this.visible;
    this.getDistributionPersons();
    this.getUserList()
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.$refs['ruleForm'].validate(valid => {
        if(!valid) return;
        let params = {
          data: []
        }
        this.skuIds.forEach((item, index) => {
          params.data.push({
            ...this.form,
            actualTime: moment(this.form.actualTime).format('YYYY-MM-DD'),
            spuId: this.spuId,
            skuId: item,
            skuCode: this.skuCodes[index],
            distributionPerson: this.form.distributionPersonId ? this.userList.find(v=>v.userId == this.form.distributionPersonId).userName : ""
          })
        });
        this.loading = true;
        this.$q.newProduct.confirmArrival(params)
          .then(({success}) => {
            if (success) {
              this.$notify.success({
                title: '成功',
                message: '确认组货成功',
              });
              this.updateVal();
              this.skuIds.length === 1 && this.$emit('success', {
                skuCode: this.skuCodes[0],
                skuId: this.skuIds[0]
              });
              this.skuIds.length > 1 && this.$emit('batchSuccess');
            }
          })
          .finally(() => {
            this.loading = false;
          });
      })
    },
    getDistributionPersons() {
      let params = {
        data: []
      };
      this.skuCodes.forEach(item=>{
        params.data.push({
          skuCode: item,
          spuId: this.spuId
        })
      })
      this.$q.newProduct.getDistributionPersons(params)
        .then(({data}) => {
          data = data.map(v=>v.distributionPersonId);
          data = Array.from(new Set(data));
          if(data.length === 1) {
            this.$set(this.form, 'distributionPersonId', data[0])
          }
        });
    },
    getUserList() {
      let data = {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "getUserInfoByName",
      }
      axios.post(`/ec-pc-api/custom/reports/data/getUserInfoByName`, data).then((res) => {
        if (res.code == 200) {
          console.log(res.data);
          this.userList = res.data.list;
        }
      });
    },
  }
}
</script>

<style>

</style>